export default {
	title: "Vip-nivå",
	current: "Gjeldende VIP-nivå",
	status: {
		btn: ["Aktivert", "Registrer deg nå"]
	}
};
